export default [
    {
        path: '/monthly-attendences',
        name: 'monthly-attendence',
        meta: { requiresAuth: true },
        component: () => import('@/pages/human-resource/monthly-attendence/index.vue')
    }
]
